export default "__VITE_ASSET__B43QWqc7__"